var _defs, _circle, _path, _path2, _path3, _circle2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAboutProg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fab29b;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31,
    cy: 26.5,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.6,43.7c.6,0,1-.4,1-1h0V12.9c0-.4.5-.8,1-.8h44.7c.6,0,1,.4,1,.8v29.8c0,.6.4,1,1,1s1-.4,1-1V12.9c0-1.6-1.4-2.8-3-2.8H9.6c-1.6,0-3,1.2-3,2.8v29.8c0,.6.4,1,1,1h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,45.7h-17c-.8,0-1.1.7-1,1.4,0,.6-.4,1-1,1h-16c-.6,0-1-.4-1-1,0-.7-.2-1.4-1-1.4H5c-.6,0-1,.4-1,1,0,0,0,0,0,0v3.1c0,2.2,1.8,4,4,4h48c2.2,0,4-1.8,4-4v-3.1c0-.6-.4-1-1-1h0ZM58,49.8c0,1.1-.9,2-2,2H8c-1.1,0-2-.9-2-2v-2.1h15.1c.3,1.4,1.5,2.4,2.9,2.4h16c1.4,0,2.7-1,2.9-2.4h15.1v2.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,16.9c-6.6,0-12,5.4-12,12s5.4,12,12,12,12-5.4,12-12c0-6.6-5.4-12-12-12ZM32,38.9c-5.5,0-10-4.5-10-10s4.5-10,10-10,10,4.5,10,10c0,5.5-4.5,10-10,10Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 23.2,
    r: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,27.2c0-.6-.4-1-1-1h-1.5c-.6,0-1,.4-1,1s.4,1,1,1h.5v6h-.5c-.6,0-1,.4-1,1s.4,1,1,1h3c.6,0,1-.4,1-1s-.4-1-1-1h-.5v-7Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAboutProg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AboutProg.90d0b0ffa7be021cb255728896d67373.svg";